import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from './redux/actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../common/Loading.jsx';
import Helmet from 'react-helmet';
import UserUtils from '../utils/UserUtils';
import NotFoundView from '../common/NotFound.Component.jsx';
import * as ShareButtons from '../common/ShareButtons.jsx';

class PublicUser extends React.Component {
  componentWillMount() {
    const {getPublicProfile, params, user, notFound} = this.props;

    if (!user && !notFound) {
      getPublicProfile(params.id);
    }
  }

  componentWillUnmount() {
    this.props.initPublicProfile();
  }

  render() {
    const {user, isFetching, notFound, location} = this.props;

    if (notFound) {
      return <NotFoundView />;
    }

    const avatarUrl = UserUtils.getImageUrl(user);

    return (
      <div className="ba-profile">
        {isFetching ? <Loading/> : null}
        <div className="row row-wide">
          <h2 className="ba-page-header">User profile</h2>
          <div className="ba-profile-panel">
            {
              !!user &&
              <div>
                <Helmet title={`${UserUtils.getFullName(user)} - Profile Page`}
                        meta={[
                          {property: 'og:image', content: avatarUrl},
                          {
                            property: 'og:description',
                            content: `Public Profile of ${UserUtils.getFullName(user)}`
                          }]}/>
                <div className="row">
                  <div className="small-12 columns padding-1x text-right">
                    <ShareButtons.FacebookButton location={location}/>
                    <ShareButtons.TwitterButton location={location}/>
                    <ShareButtons.LinkedInButton location={location}/>
                    <ShareButtons.GooglePlusButton location={location}/>
                    <ShareButtons.PinterestButton location={location} mediaUrl={avatarUrl}/>
                    <ShareButtons.TumblrButton location={location}/>
                  </div>
                  <div className="small-12 medium-3 columns">
                    <img className="ba-profile-info-avatar"
                         src={avatarUrl}/>
                  </div>
                  <div className="small-12 medium-9 columns">
                    <div className="ba-profile-field-readonly">
                      {user.firstName}
                    </div>
                    <div className="ba-profile-field-readonly">
                      {user.lastName}
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="email fa fa-envelope ba-profile-icon-display"/>
                      <span>
                        {user.email}
                      </span>
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="email fa fa-link ba-profile-icon-display"/>
                      {user.website}
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="facebook fa fa-facebook-official ba-profile-icon-display"/>
                      {user.facebook}
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="instagram fa fa-instagram ba-profile-icon-display"/>
                      {user.instagram}
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="linkedin fa fa-linkedin-square ba-profile-icon-display"/>
                      {user.linkedin}
                    </div>
                    <div className="ba-profile-field-readonly">
                      <span className="twitter fa fa-twitter ba-profile-icon-display"/>
                      {user.twitter}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.publicProfile
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

PublicUser.displayName = 'PublicUser';
PublicUser.contextTypes = {
  router: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicUser);



// WEBPACK FOOTER //
// ./shared/publicUser/PublicUser.jsx